import { render, staticRenderFns } from "./LightBox.html?vue&type=template&id=720d9b50&"
import script from "./LightBox.ts?vue&type=script&lang=ts&"
export * from "./LightBox.ts?vue&type=script&lang=ts&"
import style0 from "./LightBox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
